import "./FieldSet.scss";
import { useEffect, useState, useContext } from "react";
import {
  Col,
  Row,
  Input,
  DatePicker,
  Select,
  Form,
  Radio,
  Checkbox,
  Icon,
  Divider,
  Upload,
  Button,
  List,
  notification
} from "antd";

import { useTranslation } from "react-i18next";
import moment from "moment";
import { globalContext } from "../../../../../contexts";
import { validateRutHelper } from "../../helpers";
import apiConfig from "../../../../../config/api";
import FormConfigBadges from '../FormConfigBadges/FormConfigBadges';

const FieldSet = ({ formId, client, record, form, section, parent, component, mode, lang, showErrors, handleChangeValues, cleanFields }) => {
  const { t } = useTranslation('forms')
  const { getFieldDecorator, validateFields, getFieldsError, setFieldsValue } = form;
  const [ hasErrors, setHasErrors ] = useState(false)
  const [ changes, setChanges ] = useState(false)
  const [ keyValidate, setKeyValidate ] = useState(Math.random())
  const { datasources, currentUser } = useContext(globalContext)
  const formLayout = component.orientation ? component.orientation : "vertical"

  useEffect(() => {
    if(mode === "html") {
      let errores = component.fields.filter(f => f.required && f.typeField !== 'SUBTITLE' && (f.value === null || f.value === undefined || f.value === ''));
      setHasErrors(errores.length > 0)
      validateErrors()
    }
  }, [keyValidate])

  useEffect(() => {
    if(cleanFields) {
      const valuesToClear = {};
      component.fields && component.fields.map(field => {
        field.value = null
        field.fileList = null
        field.placeholder = null
        valuesToClear[field.id] = undefined;
      })
      setFieldsValue(valuesToClear)
    }
  }, [cleanFields])

  const isFieldVisible = (field, level=1) => {
    let visible = true
    if(field.visibility) {
      if(field.visibility.visible === false && field.visibility.fieldId && field.visibility.fieldValue) {
        const fieldCondition = component.fields.filter(f => f.id === field.visibility.fieldId && f.id !== field.id)
        if(fieldCondition.length === 1) {
          if(Array.isArray(field.visibility.fieldValue)) {
            if(!field.visibility.fieldValue.includes(fieldCondition[0].value)) {
              visible = false
            }
          }else {
            if(field.visibility.fieldValue !== fieldCondition[0].value) {
              visible = false
            }
          }
          if(visible && level < 5) {
            visible = isFieldVisible(fieldCondition[0], level+1)
          }
        }
      }
    }
    if(level === 1) {
      field.visible = visible
    }
    return visible
  }

  const validateErrors = () => {
    component.fields.map(f => {
      f.errors = false
    })
    setHasErrors(false)

    validateFields()
    .then(fields => {
      console.log(fields)
    })
    .catch(({errors}) => {
      Object.keys(errors).map(e => {
        component.fields.filter(f => f.id === e || (f.typeField === "RADIOOTHER" && (f.id + '-OTHER') === e)).map(f => {
          f.errors = errors[e].errors
        })
      })
      setHasErrors(true)
    })
  }

  const handleChangeFieldValue = (field, value) => {
    if(mode !== "pdf") {
      field.value = value
      field.text = undefined

      if(field.source) {
        const values = getValuesFromDS(field)
        if(values) {
          const valueSelected = values.find(v => v.code === value)
          if(valueSelected && valueSelected.jsonValue && valueSelected.jsonValue[lang]) {
            field.text = valueSelected.jsonValue[lang]
          }
        }
      }
      if(field.typeField === "SELECT" && component.fields) {
        const allPrefilled = component.fields.filter(f => f.typeField === "INPUT" && f.validation?.fieldPrefilledId === field.id && f.validation?.fieldPrefilledOption)
        const fieldPrefilled = allPrefilled.filter(f => f.validation?.fieldPrefilledValue === value)
        allPrefilled.map(f => {
          f.placeholder = ""
        })
        fieldPrefilled.map(f => {
          if(record && mode === "html") {
            if(f.validation.fieldPrefilledOption === "rut") {
              f.value = record.rut
              setFieldsValue({[f.id]: record.rut})
            }else if(f.validation.fieldPrefilledOption === "name") {
              f.value = record.nombre
              setFieldsValue({[f.id]: record.nombre})
            }else if(f.validation.fieldPrefilledOption === "email") {
              f.value = record.email
              setFieldsValue({[f.id]: record.email})
            }else if(f.validation.fieldPrefilledOption === "company" && record.subcliente) {
              f.value = record.subcliente.name
              setFieldsValue({[f.id]: record.subcliente.name})
            }
          }else {
            if(f.validation.fieldPrefilledOption) {
              f.placeholder = "«" + t('forms.validation.prefilled.' + f.validation.fieldPrefilledOption) + "»"
            }
          }
        })
      }
      setKeyValidate(Math.random())
      setChanges(true)
      handleChangeValues && handleChangeValues(component)
    }
  }

  const handleReadOnly = (field,readOnly)=>{
    field.readOnly = readOnly
    handleChangeValues(component)
  }

  const handleOnBlur = (field, readOnly) => {
    field.errors = null
    validateErrors()

    handleReadOnly(field, readOnly)
  }

  const getParentFromDS = (field) => {
    if(field.source && field.source.indexOf(':') > 0) {
      let ds = field.source.split(':')
      if(datasources && datasources[ds[0]] && datasources[ds[0]][ds[1]]) {
        let datasource = datasources[ds[0]][ds[1]] 
        if(datasource.parent) {
          let parent = component.fields.find(f => f.source === ds[0]+':'+datasource.parent)
          return parent
        }
      }
    }
    return null
  }

  const getValuesFromDS = (field) => {
    if(datasources && field.source && field.source.indexOf(':') > 0) {
      let ds = field.source.split(':')
      if(datasources[ds[0]] && datasources[ds[0]][ds[1]]) {
        let datasource = datasources[ds[0]][ds[1]] 
        if(datasource.parent) {
          let parent = component.fields.find(f => f.source === ds[0]+':'+datasource.parent)
          if(datasources[ds[0]][datasource.parent]) {
            const values = datasources[ds[0]][datasource.parent].values
            let parValue
            if(parent) {
              parValue = values.find(v => v.code === parent.value)
            }else if(datasource.parent === "COUNTRIES") {
              let countryCode = ""
              if(currentUser?.cliente) {
                countryCode = currentUser.cliente.pais === "CHI" ? "CL" : currentUser.cliente.pais === "PER" ? "PE" : ""
              }else if(client) {
                countryCode = client.pais === "CHI" ? "CL" : client.pais === "PER" ? "PE" : ""
              }
              parValue = values.find(v => v.code === countryCode)
            }
            return datasource.values.filter(v => v.parent == parValue?.code)
          }
        }
        return datasource.values
      }
    }
    return [{code: 'no-data', value: {es: "No hay datos", en: "No data", pt: "No dados"}}]
  }

  const getObjValidator = (field) => {
    const validation = field.validation
    let applyValidation = true
    if(!validation) {
      applyValidation = false
    }else if(validation?.fieldConditionId) {
      const fieldValidation = component.fields.filter(f => f.id === validation.fieldConditionId)
      if(fieldValidation.length === 1) {
        if(fieldValidation[0].value !== validation.fieldConditionValue) {
          applyValidation = false
        }
      }
    }
    if(applyValidation) {
      if(validation?.type === 'email') {
        return {type: "email", message: t('forms.errors.email')}
      }else {
        return {validator: (rule, value, callback) => {
          if(value === undefined || value === null || value === '') {
            callback()
          } else {
            if(validation.type === 'number' || validation.type === 'percent') {
              value = value.replaceAll(',','.')
              let re = new RegExp('^\\s*(\\d+(\\.\\d{0,' + (validation.decimals ? validation.decimals : 0) + '})?)\\s*$')
              if(re.test(value)) {
                if(validation.type === 'percent' && parseFloat(value) > 100) {
                  callback(t('forms.errors.NUMERO_MAYOR_100'));
                }else {
                  callback()
                }
              }else {
                var ren = new RegExp('^\\s*(\\d+(\\.\\d{0,100})?)\\s*$')
                if(validation.decimals === 0 && ren.test(value)) {
                  callback(t('forms.errors.NUMERO_NO_DECIMALES'));
                }else {
                  callback(t('forms.errors.NUMERO_NO_VALIDO'));
                }
              }
            }else if(validation.type === 'rut' || validation.type === 'rutEmp' || validation.type === 'rutNat') {
              let type = ''
              if(validation.type === 'rutEmp') type = 'Entity'
              else if(validation.type === 'rutNat') type = 'Person'
              if(validateRutHelper(value, type)) {
                callback()
              }else {
                if(validation.type === 'rut') {
                  callback(t('forms.errors.RUT_NO_VALIDO'));
                }else if(validation.type === 'rutEmp') {
                  callback(t('forms.errors.RUT_EMPRESA_NO_VALIDO'));
                }else if(validation.type === 'rutNat') {
                  callback(t('forms.errors.RUT_PERSONA_NO_VALIDO'));
                }
              }
            }
          }
        }}
      }
    }else {
      return {type: "string"}
    }
  }

  const formItemLayout =
      formLayout === 'horizontal'
        ? {
            labelCol: { span: 8 },
            wrapperCol: { span: 16 },
          }
        : null;

  const getDefaultValue = (field) => {
    if(field.value !== null && field.value !== undefined && field.value !== '') {
      if(field.typeField === 'DATE') return moment(field.value, 'DD/MM/YYYY')
      else if(field.typeField === 'CHKOPTS') return field.value.split(',')
      else if(field.typeField === 'RADIOOTHER' && field.value.startsWith('OTHER-')) return 'OTHER'
    }
    return field.value??""
  }

  const getLabelValue = (field) => {
    if(field.value) {
      if(field.typeField === 'SELECT') {
        const values = getValuesFromDS(field)
        const val = values.filter(v => v.code === field.value)
        if(val.length === 1 && val[0].jsonValue) {
          return val[0].jsonValue[lang]
        }
      }
    }
    return field.value
  }

  const getValidation = (field) => {
    if(field.validation?.type) {
      return true
    }else {
      return false
    }
  }

  const handleRemove = (field) => {
    field.fileList = null
    handleChangeFieldValue(field, null)
    validateErrors()
  };

  const getPropsUpload = (field) => {
    const minSizeKB = 0
    const maxSizeKB = field.validation?.maxSize ?? 5120
    const allowedFormats = field.validation?.acceptedFormats ?? ['.jpg', '.jpeg', '.png', '.pdf', '.docx']

    if(mode !== "html") return {}
    else {
      return {
        accept: allowedFormats,
        name: 'file',
        multiple: false,
        showUploadList: false,
        fileList: field.fileList ?? [],
        action: apiConfig.url + '/form/uploadFile?formId='+formId,
        beforeUpload: (file) => {
          const isAllowedFormat = allowedFormats.some(ext => file.name.toLowerCase().endsWith(ext))
          const sizeAllowed = (file.size / 1024 <= maxSizeKB) && (file.size > minSizeKB)

          if (!isAllowedFormat) {
            notification.error({
                message: t('forms.manager.validation.invalidFormat'),
                description: `${t('forms.manager.validation.selectFormats')}: ${allowedFormats.join(', ')}`,
              });
            file.status = 'error';
            return false
          }

          if (!sizeAllowed) {
            notification.error({
                message: t('forms.manager.validation.invalidSize'),
                description: `${t('forms.manager.validation.maxSizeKB')}: ${maxSizeKB} KB`,
              });
            file.status = 'error';
            return false
          }

          return true
        },
        onChange(info) {
          const { status, response, name } = info.file
          const latestFile = info.fileList.slice(-1);
          field.fileList = latestFile

          if(status !== 'error') {
            if(status === "done") {
                handleChangeFieldValue(field, {name, path: response});
            }
          }else {
            field.fileList = null
            handleChangeFieldValue(field, null);
          }
          validateErrors()
        }
      }
    }
  };

  return (
    <div className={'form-manager-fieldset '+section.type + ' ' + mode}>
      { mode !== 'pdf' && showErrors && hasErrors &&
        <Row className="has-errors-fieldset">
          { (component.fields.filter(f => f.errors).length > 0) ?
           t('forms.errors.requiredFields')
           :
           t('forms.errors.invalidData')
          }
        </Row>
      }
      { component.hasTitle &&
        <Row className="fieldset-title">
          {component.title && component.title[lang]}
        </Row>
      }
      { component.fields &&
        <Row className={"fields-fieldset showErrors-" + showErrors + " changes-"+changes + " changes-errors-"+showErrors+"-"+changes} gutter={12}>
          <Form layout={formLayout === 'horizontal' ? 'horizontal':null} className={'formLayout-'+formLayout}>
          { component.fields.map(field =>
            (field.typeField === 'SUBTITLE') ?
              <Col span={24}>
                <Divider orientation="left">{field.title && field.title[lang]}</Divider>
              </Col>
            : isFieldVisible(field) &&
              <Col span={24/component.cols}>
                <Form.Item label={field.typeField !== 'SUBTITLE' && <>
                  {field.title && field.title[lang]}
                  <FormConfigBadges mode={mode} record={field.record} risks={field.risks}
                    riskConditionKey={field.typeField === 'CHECKBOX' ? 'checked' : null}
                    relatedRecord={parent?.type === 'TABLE' || parent?.type === 'DECL'} />
                </>} {...formItemLayout} style={field.typeField === 'RADIOOTHER' ? {float:'left'} : null}>
                  { mode === 'pdf' && field.typeField !== 'CHECKBOX' && field.typeField !== 'RADIO' && field.typeField !== 'RADIOOTHER' && field.typeField !== 'CHKOPTS' && field.typeField !== 'FILE' ?
                    <div className="div-field-value">
                      <div>
                        <span className="span-field-value">{getLabelValue(field)}{field.validation && field.validation.type === 'percent' ? <Icon type="percentage" /> : null}</span>
                      </div>
                    </div>
                    :
                    <>
                      { getFieldDecorator(field.id, {
                        initialValue: getDefaultValue(field),
                        rules:
                          [
                            { required: mode !== 'pdf' && field.required, message: t('forms.errors.required') },
                            ...getValidation(field) ? [getObjValidator(field)] : [],
                            ...field.typeField === 'INPUT' && field.validation?.maxLength ? [{ validator: (rule, value, callback) => {
                              if (value && value.length > field.validation.maxLength) {
                                callback(t('forms.errors.maxLength', {max: field.validation.maxLength}));
                              } else {
                                callback();
                              }
                            }}] : [],
                          ]
                      })(
                        field.typeField === 'INPUT' ?
                          <Input
                            placeholder={field.placeholder}
                            autoComplete="off"
                            onFocus= {(e)=>handleChangeValues && handleReadOnly(field,false)}
                            onBlur= {(e)=>handleChangeValues && handleOnBlur(field,true)}
                            readOnly = {mode === "pdf" || field.readOnly}
                            maxLength={field.validation?.maxLength ? field.validation?.maxLength+1 : 150}
                            onChange={(e) => handleChangeFieldValue(field, e.target.value)}
                            suffix={field.validation && field.validation.type === 'percent' ? <Icon type="percentage" />: null}
                          />
                        : field.typeField === 'SELECT' ?
                          ( (!getParentFromDS(field) || getValuesFromDS(field).length > 0) ?
                            <Select
                              showSearch
                              filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                              }
                              onFocus= {(e)=>handleChangeValues && handleReadOnly(field,false)}
                              onBlur= {(e)=>handleChangeValues && handleOnBlur(field,true)}
                              readOnly = {field.readOnly !== false}
                              onChange={(value) => handleChangeFieldValue(field, value)}>
                                { getValuesFromDS(field).map(val =>
                                  <Select.Option value={val.code}>{val.jsonValue && val.jsonValue[lang]}</Select.Option>
                                )}
                            </Select>
                            :
                            <Input
                              autoComplete="off"
                              onFocus= {(e)=>handleChangeValues && handleReadOnly(field,false)}
                              onBlur= {(e)=>handleChangeValues && handleOnBlur(field,true)}
                              readOnly = {mode === "pdf" || field.readOnly}
                              maxLength={field.validation && field.validation.maxLength ? field.validation && field.validation.maxLength : 500}
                              onChange={(e) => handleChangeFieldValue(field, e.target.value)}
                              suffix={field.validation && field.validation.type === 'percent' ? <Icon type="percentage" />: null}
                            />
                            )
                        : field.typeField === 'RADIO' || field.typeField === 'RADIOOTHER' ?
                          (
                            mode === 'pdf' ?
                            <Row style={{position:'relative', padding: '5px 0px', minHeight:40}}>
                              { getValuesFromDS(field).map(val =>
                                  <div className="div-radio">
                                    <input type="radio" checked={val.code === getDefaultValue(field)}/> {val.jsonValue && val.jsonValue[lang]}
                                  </div>
                              )}
                              {  field.typeField === 'RADIOOTHER' && field.value && field.value.startsWith('OTHER') &&
                                  <div className="div-radio">
                                    <input type="radio" checked={getDefaultValue(field) === "OTHER"}/> {field.value.substring(6)}
                                  </div>
                              }
                            </Row>
                            :
                              <Radio.Group
                                onChange={(e) => handleChangeFieldValue(field, e.target.value)}>
                                  { getValuesFromDS(field).map(val =>
                                    <Radio value={val.code}>{val.jsonValue && val.jsonValue[lang]}</Radio>
                                  )}
                                  { field.typeField === 'RADIOOTHER' &&
                                      <Radio value="OTHER">{t("forms.options.otro")}</Radio>
                                  }
                              </Radio.Group>
                          )
                        : field.typeField === 'CHECKBOX' ?
                          (mode === 'pdf' ?
                            <Row style={{padding: '5px 0px', minHeight:36}}>
                              <div className="div-checkbox">
                                <input type="checkbox" checked={field.value}/>
                              </div>
                            </Row>
                            :
                            <Checkbox checked={field.value}
                              onChange={(e) => handleChangeFieldValue(field, e.target.checked)}
                            />
                          )
                        : field.typeField === 'CHKOPTS' ?
                          (mode === 'pdf' ?
                            <Row style={{position:'relative', padding: '5px 0px', minHeight:36}}>
                              { getValuesFromDS(field).map(val =>
                                <div className="div-checkbox">
                                  <input type="checkbox" readOnly={true} checked={field.value && field.value.split(',').includes(val.code) }/> {val.jsonValue && val.jsonValue[lang]}
                                </div>
                              )}
                            </Row>
                            :
                            <Checkbox.Group
                              onChange={(values) => handleChangeFieldValue(field, values.toString())}
                              options={getValuesFromDS(field).map(val => {return {value: val.code, label: val.jsonValue && val.jsonValue[lang]}})}
                              />
                          )
                        : field.typeField === 'DATE' ?
                          <DatePicker placeholder="Ingrese la fecha" 
                            format="DD/MM/YYYY"
                            onChange={(momentObj) => handleChangeFieldValue(field, momentObj ? moment(momentObj).format( "DD/MM/YYYY" ) : null ) } 
                          />
                        : field.typeField === 'FILE' &&
                          (mode === 'pdf' ?
                            <div className="div-field-value">
                              <div>
                                <span className="span-field-value">
                                  {field.value &&
                                    <a className="link-file" target="_blank" download={field.value.name} href={apiConfig.url + "/form/getFile/" + formId + "?name=" + encodeURI(field.value.name) + "&path=" + encodeURI(field.value.path)}>{field.value.name}</a>
                                  }
                                </span>
                              </div>
                            </div>
                            :
                            <div>
                              <div style={{float:'left', height:40}}>
                                <Upload  {...getPropsUpload(field)} disabled={mode !== "html"}>
                                  <Button size="small" style={{height:30, padding:'0px 10px'}}>
                                      <Icon type="arrow-up" size="small"/>
                                      {t("messages.aml.file.manager.add.file", {ns: "translations"})}
                                  </Button>
                                </Upload>
                              </div>
                              { field.fileList?.length > 0 &&
                                <div style={{float:'left', height:40, verticalAlign:'middle', marginLeft:10}}>
                                  <List
                                    size="small"
                                    className="file-list"
                                    bordered
                                    dataSource={field.fileList??[]}
                                    renderItem={file => (
                                      <List.Item 
                                        actions={
                                          [<Button icon="delete" size="small" onClick={() => handleRemove(field)}/>]
                                        }
                                      >
                                        <Icon type="paper-clip" size="small"/>
                                        <div className="text-file-name">{file.name}</div>
                                      </List.Item>
                                    )}
                                  />
                                </div>
                              }
                            </div>
                          )
                      )}

                    </>
                  }
                </Form.Item>
                { mode !== 'pdf' && field.typeField === 'RADIOOTHER' && field.value && field.value.startsWith('OTHER') &&
                  <Form.Item>
                    { getFieldDecorator(field.id + '-OTHER', {
                          initialValue: field.value.substring(6),
                          rules:
                            [
                              { required: true, message: t('forms.errors.required') },
                            ]
                        })(
                          <Input size="small" placeholder={t("forms.options.otro")} onChange={(e) => handleChangeFieldValue(field, 'OTHER-'+e.target.value)}/>
                        )
                    }
                  </Form.Item>
                }
              </Col>
          )}
          </Form>
        </Row>
      }
    </div>
  )
}

export default Form.create()(FieldSet);
